import * as React from 'react';
import {
    CalendarPrintPreviewProps,
    CalendarPrintPreviewStyleProps,
    CalendarPrintPreviewStyles,
} from './CalendarPrintPreview.types';
import { getPivotItems } from './getPivotItems';
import { classNamesFunction } from '@fluentui/react/lib/Utilities';

const getClassNames = classNamesFunction<
    CalendarPrintPreviewStyleProps,
    CalendarPrintPreviewStyles
>();

/** The base non-styled version of CalendarPrintPreview. */
export function CalendarPrintPreviewBase<TEvent>(props: CalendarPrintPreviewProps<TEvent>) {
    // Styles
    const { styles, theme, className, agenda, pageZoom = 0.55, isRTL } = props;
    const classNames = getClassNames(styles, {
        theme: theme!,
        className: className,
        pageZoom: pageZoom!,
        agenda: agenda!,
        isRTL: isRTL,
    });

    // Calculated Properties
    const pivotItems = getPivotItems(classNames, props);

    return (
        <div className={classNames.root}>
            <div className={classNames.pivot}>{pivotItems}</div>
        </div>
    );
}
